/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'apple': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M91.688 33c-9.348 3.156-16.633 6.316-15.594 20 9.348-2.105 17.672-7.367 15.594-20zM62 52c-9 0-22 8-22 23 0 21 14 42 22 42 6 0 11-4 15-4s8 4 14 4c8 0 17-12 19-23-7-5-12-8-12-17 0-6 5-12 11-17-3-4-9-8-15-8s-12.453 4.746-17 5c-4 0-9-5-15-5z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
